import { Send } from "lucide-react";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Icon from "./Icon";

// Ekran kengligiga qarab video yuklashni hal qiladi (mobil = video umuman yuklanmaydi, asl dizayn qoladi)
function useIsDesktop(breakpoint = 768) {
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${breakpoint}px)`);
    setIsDesktop(mq.matches);
    const handler = (e) => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [breakpoint]);
  return isDesktop;
}

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, delay, ease: [0.4, 0, 0.2, 1] },
});

export default function Hero({ hero, scrollToForm }) {
  const isDesktop = useIsDesktop(); // hook har doim early return'dan oldin chaqiriladi

  if (!hero) return null;  // ← shu qatorni qo'shing

  return (
    <section className="relative overflow-hidden bg-[#fafafa] py-24 pb-5 md:py-0 md:min-h-screen md:flex md:items-center">
      {/* Background */}
      <div className="pointer-events-none absolute inset-0">
        {/* Video faqat desktop'da, butun ekranni qoplaydi. Mobilda umuman yuklanmaydi — asl dizayn saqlanadi */}
        {isDesktop && (
          <video
            className="absolute inset-0 h-full w-full object-cover"
            src="/hero-bg.mp4"
            poster="/hero-poster.jpg"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          />
        )}

        <div className="absolute -top-28 -right-20 h-[520px] w-[520px] rounded-full"
          style={{ background: "radial-gradient(circle at 60% 40%,rgba(139,92,246,.12) 0%,transparent 68%)" }} />
        <div className="absolute -bottom-16 -left-14 h-[360px] w-[360px] rounded-full"
          style={{ background: "radial-gradient(circle,rgba(124,58,237,.06) 0%,transparent 65%)" }} />
        <div className="absolute inset-0" style={{
          backgroundImage: "linear-gradient(rgba(124,58,237,.03) 1px,transparent 1px),linear-gradient(90deg,rgba(124,58,237,.03) 1px,transparent 1px)",
          backgroundSize: "48px 48px"
        }} />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-5 w-full">
        <div className="max-w-[640px]">

          <motion.div className="mb-5 flex flex-wrap gap-2" {...fadeUp(0)}>
            {hero.tags.map((t, i) => (
              <span key={i} className={
                "inline-flex items-center gap-1.5 rounded-full border-[1.5px] px-3 py-[5px] text-[11.5px] font-bold backdrop-blur-md " +
                (isDesktop
                  ? "border-white/30 bg-white/15 text-white"
                  : (t.type === "green"  ? "border-green-200  bg-green-50  text-green-700"  :
                     t.type === "violet" ? "border-violet-200 bg-violet-50 text-violet-700" :
                                           "border-blue-200   bg-blue-50   text-blue-700"))
              }>
                {t.type === "green" && (
                  <span className="inline-block h-[7px] w-[7px] animate-pulse rounded-full bg-green-400" />
                )}
                {t.label}
              </span>
            ))}
          </motion.div>

          <motion.h1
            className={"mb-4 font-extrabold leading-[1.08] tracking-[-0.03em] " + (isDesktop ? "text-white [text-shadow:0_2px_20px_rgba(0,0,0,.35)]" : "text-gray-950")}
            style={{ fontSize: "clamp(28px,5vw,52px)" }}
            {...fadeUp(0.08)}>
            {hero.title}{" "}
            <span className={isDesktop ? "text-violet-300" : "text-violet-600"}>{hero.titleHighlight}</span>{" "}
            {hero.titleEnd}
          </motion.h1>

          <motion.p className={"mb-7 max-w-[440px] text-[15px] leading-[1.75] " + (isDesktop ? "text-gray-100/90 [text-shadow:0_1px_12px_rgba(0,0,0,.3)]" : "text-gray-500")} {...fadeUp(0.15)}>
            {hero.subtitle}
          </motion.p>

          <motion.div className="mb-7 flex flex-col gap-3 sm:flex-row sm:flex-wrap" {...fadeUp(0.22)}>
            <button
              onClick={scrollToForm}
              className="w-full rounded-[14px] bg-violet-600 px-6 py-[13px] text-sm font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-violet-700 sm:w-auto"
              style={{ boxShadow: "0 4px 16px rgba(124,58,237,.22)" }}>
              {hero.ctaPrimary} →
            </button>
            <a href={hero.telegramLink} target="_blank" rel="noreferrer"
              className={"flex w-full items-center justify-center gap-2 rounded-[14px] border-[1.5px] px-5 py-3 text-sm font-bold no-underline transition-all hover:-translate-y-0.5 sm:w-auto " +
                (isDesktop
                  ? "border-white/30 bg-white/10 text-white backdrop-blur-md hover:bg-white/20"
                  : "border-blue-200 bg-white text-blue-600 hover:bg-blue-50")}>
              <Send size={15} />
              {hero.ctaTelegram}
            </a>
          </motion.div>

          <motion.div className="flex flex-wrap gap-x-5 gap-y-3" {...fadeUp(0.28)}>
            {hero.meta.map((m, i) => (
              <div key={i} className={"flex items-center gap-1.5 text-[13px] " + (isDesktop ? "text-gray-200/90" : "text-gray-400")}>
                <Icon name={m.icon} size={14} color={isDesktop ? "#e5e7eb" : "#9ca3af"} />
                <span>{m.text}</span>
              </div>
            ))}
          </motion.div>

        </div>
      </div>
    </section>
  );
}